<template>
    <div>
        <form data-vv-scope="GraphSave">
          <!-- {{get_platform_modules_item_data}} -->
<!-- {{graph_type}}
{{x_axis}}
{{y_axis}}
{{platform_module_id}} -->
    <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
      <vs-input
        v-validate="'required'"
        name="name"
        v-model="name"
        class="custom_Input"
        label="Name"
        icon-pack="feather"
        icon="icon-edit"
        icon-after
        style="width: 100%"
      />
      <span v-show="errors.has('GraphSave.name')" class="text-danger">{{
        errors.first("GraphSave.name")
      }}</span>
    </vs-col>
    <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
      <vs-input
        name="description"
        v-model="description"
        class="custom_Input"
        label="Description"
        icon-pack="feather"
        icon="icon-edit"
        icon-after
        style="width: 100%"
      />
    </vs-col>
        <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
                      <vs-button class="ml-auto mt-2" @click="validatingGraph()">Save</vs-button>

        </vs-col>


    <!-- <vs-input
      class="w-full my-base"
      label-placeholder="Company"
      v-model="company"
    ></vs-input> -->

    <!-- Save & Reset Button -->
          </form>

    </div>
</template>

<script>
import {saveGraphApi} from '@/api/graph'
import { mapActions, mapGetters } from 'vuex'

export default {
  props:{
    graph_type:{required:true, type:String},
    x_axis:{required:true, type:Number},
    y_axis:{required:true, type:Number},
    platform_module_id:{required:true, type:Number},
    dateRange:{required:true, type:Object}

  },
  data () {
    return {
      name:'',
      description:''
    }
  },
  mounted () {
    // this.Add_NEW_GRAPH_TO_MODULE_ACTION({name:'yasin'})
  },
  methods:{
    ...mapActions(['Add_NEW_GRAPH_TO_MODULE_ACTION']),
    validatingGraph () {
      this.$validator.validateAll('GraphSave').then(valid => {
        if (valid) {
          this.savingGraphApi()
        } else {
          this.showSuccessMessage('Error', 'Validation Are Required', 'danger')
        }
      })

    },
    async savingGraphApi () {
      
      const additional_data = {
        start_date:this.$parent.$moment(this.dateRange.startDate).format('YYYY-MM-DD'),
        end_date:this.$parent.$moment(this.dateRange.endDate).format('YYYY-MM-DD')
      }
      const payload = {
        x_axis : this.x_axis,
        y_axis : this.y_axis,
        platform_module_id :this.platform_module_id, 
        graph_type :this.graph_type,
        name : this.name,
        description:this.description,
        additional_data,
        is_saved: true
      }
      
      try {
        const customer_id = localStorage.getItem('customer_id')
        const {data} = await saveGraphApi(customer_id, payload)
        
        const index = this.get_platform_modules_item_data.findIndex(ele => ele.platform_modules_id === this.platform_module_id)
        
        const savingGraphStorePayload = {
          index,
          data:data.data.graphs
        }
        
      
        this.Add_NEW_GRAPH_TO_MODULE_ACTION(savingGraphStorePayload)
        this.showSuccessMessage('Success', 'Graph saved successfully', 'success')
        this.$emit('closeSavePopUp')

        
      } catch (error) {
        
      }
    }
    
  },
  computed: {
    ...mapGetters(['get_platform_modules_item_data'])
  }
        
        
}
</script>

<style lang="scss" scoped>

</style>